import { go, mapL, reduce } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const _getSelectorCenterPointInViewPort = (self) => {
  const selector_nw_circle_el = self._getSelectorNWCircleElThrowable();
  const selector_ne_circle_el = self._getSelectorNECircleElThrowable();
  const selector_se_circle_el = self._getSelectorSECircleElThrowable();
  const selector_sw_circle_el = self._getSelectorSWCircleElThrowable();
  return go(
    [
      selector_nw_circle_el,
      selector_ne_circle_el,
      selector_se_circle_el,
      selector_sw_circle_el,
    ],
    mapL(CommonNS.UtilNS.getCenterPointInViewPort(self._svg_el)),
    (iter) =>
      reduce(
        (acc, cur) => {
          if (acc == null || cur == null) {
            return null;
          }
          acc.x += cur.x;
          acc.y += cur.y;
          return acc;
        },
        CommonNS.UtilNS.createSVGPoint(self._svg_el)([0, 0]),
        iter
      ),
    (point) => {
      if (point == null) {
        return null;
      }
      point.x = point.x / 4;
      point.y = point.y / 4;
      return point;
    }
  );
};
